module.exports = __webpack_public_path__ + "static/abra-a641fcd24b07671cdd858dcf0a9a8ade.jpg";